<script lang="ts">
  import { createQuery } from '@tanstack/svelte-query';
  import { adminLoginsApi } from '$lib/api/admin';
  import { getErrorMessage } from '$lib/api/client';
  import Modal from '$lib/components/ui/Modal.svelte';
  import Pagination from '$lib/components/ui/Pagination.svelte';
  import Chip from '$lib/components/ui/Chip.svelte';
  import type { AdminUser } from '$lib/types';

  const { user, onClose }: { user: AdminUser; onClose: () => void } = $props();

  let page = $state(1);

  const loginsQuery = createQuery(() => ({
    queryKey: ['admin-user-logins', user.id, page],
    queryFn: () => adminLoginsApi.forUser(user.id, { page, per_page: 10 })
  }));
</script>

<Modal title={`Login activity — ${user.email}`} onClose={onClose} wide>
  {#if loginsQuery.isLoading}
    <p style="color:var(--t3);font-size:13.5px">Loading logins…</p>
  {:else if loginsQuery.isError}
    <p style="color:var(--danger);font-size:13.5px">{getErrorMessage(loginsQuery.error)}</p>
  {:else if loginsQuery.data}
    <div class="card table-scroll">
      <table class="table">
        <thead>
          <tr>
            <th>Time</th>
            <th>IP</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          {#each loginsQuery.data.results as row (row.id)}
            <tr>
              <td>{new Date(row.created_at).toLocaleString()}</td>
              <td class="mono">{row.ip_address || '—'}</td>
              <td><Chip label={`${row.browser} · ${row.os} · ${row.device}`} kind="gray" /></td>
            </tr>
          {:else}
            <tr><td colspan="3" style="text-align:center;color:var(--t3);padding:32px">No logins recorded yet.</td></tr>
          {/each}
        </tbody>
      </table>
    </div>
    <Pagination
      page={loginsQuery.data.page}
      perPage={loginsQuery.data.per_page}
      count={loginsQuery.data.count}
      onChange={(p) => (page = p)}
    />
  {/if}
</Modal>
